import 'core-js/stable'
import 'regenerator-runtime/runtime'

import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import { initLoginFormById } from './integrations/authentication'
import { initRouteItems } from './integrations/routes'

initGlobal()
initPageHeader()
initPageFooter()

initLoginFormById('login')
initRouteItems()
